import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestService } from '../../services/rest.service';

@Component({
  selector: 'app-profile-shell-users-tab',
  templateUrl: './profile-shell-users-tab.component.html',
  styleUrls: ['./profile-shell-users-tab.component.scss']
})
export class ProfileShellUsersTabComponent implements OnInit {

  constructor(
      private http: HttpClient
    , private rest: RestService
  ) {}

  public userCreateTest = {
    user_permissions: 'admin'
  };
  public errorMessage = '';
  public successMessage = '';

  public userUpdateTest = {
      title: ''
    , first_name: ''
    , last_name: ''
    , phone_number: ''
    , email: ''
    , user_permissions: ''
  };

  public po_column_defs = [
      {headerName: 'Title', field: 'title'}
    , {headerName: 'First Name', field: 'first_name'}
    , {headerName: 'Last Name', field: 'last_name'}
    , {headerName: 'Phone #', field: 'phone_number'}
    // , {headerName: 'Login', field: 'login'}
    , {headerName: 'E-mail', field: 'email'}
    , {headerName: 'Permissions', field: 'permissions'}
    , {headerName: 'Edit'}
  ];

  public users: any = [];

  ngOnInit() {
    this.refreshPageData();
  }

  refreshPageData() {
    this.rest.getUsersForMyDistributorEntity()
      .subscribe((data) => {
        this.errorMessage = '';
        this.users = data;
        this.successMessage = '';
      }, (error) => {
        this.successMessage = '';
        this.errorMessage = 'Could not load users';
      });
  }

  submitUserCreate(event) {
    if (event && event.success) {
      this.refreshPageData();
    }
  }

  submitUserUpdate(event) {
    if (event && event.success) {
      console.log('I BE UPDATING');
      this.refreshPageData();
    }
  }

  submitUserDelete(event) {
    console.log(event);
    if (event && event.success) {
      this.refreshPageData();
    }
  }

}
